import moment from "moment/moment";

export default class ClientModel {
  constructor(data) {
    this.id = data.id || null;
    this.age = data.age || null;
    this.assignment = data.assignment || null;
    this.assignmentLog = data.assignment_log || [];
    this.assignment_group = data.assignment_group || null;
    this.assignment_group_log = data.assignment_group_log || [];

    this.bad_number_state = data.bad_number_state || null;
    this.bad_number_state_id = data.bad_number_state_id || null;
    this.bn = data.bn || [];
    this.birth_date = data.birth_date || null;
    this.birth_date_display = data.birth_date_display || null;

    this.click_on_site = data.click_on_site || "";

    this.communications = data.communications || [];
    this.sms_log = data.sms_log || [];
    this.sms_log_latest = data.sms_log_latest || [];
    this.calls_log = data.calls_log || [];
    this.calls_log_latest = data.calls_log_latest || [];

    this.email_log = data.email_log || [];
    this.country = data.country || null;
    this.country_id = data.country_id || null;

    this.created_at = data.created_at || null;

    this.device = data.device || null;
    this.campaign_aaid = data.campaign_aaid || null;
    this.campaign_abid = data.campaign_abid || null;
    this.placement = data.placement || null;
    this.loc_physical_ms = data.loc_physical_ms || null;
    this.lead_loc = data.location || null;
    this.leading = data.is_leading || null;
    this.is_leading = data.is_leading !== undefined ? data.is_leading : 0;

    this.cpl = data.cost_per_lead || null;

    this.deposits = data.deposits || [];
    this.deposits_log = data.deposits_log || [];
    this.support_deposits_answers = data.support_deposits_answers || [];
    this.support_deposits_contact_docs =
      data.support_deposits_contact_docs || [];
    this.support_deposits_answers_log = data.support_deposits_answers_log || [];
    this.emails = data.emails || [];

    this.first_name = data.first_name || null;
    this.full_name = data.full_name || null;

    this.is_new = data.is_new;
    this.active = data.active;
    this.is_duplicate = data.is_duplicate;
    this.duplicate = data.duplicate;
    this.duplicates = data.duplicates || [];

    this.keyword = data.keyword || null;
    this.language = data.language || null;
    this.language_id = data.language_id || null;

    this.last_name = data.last_name || null;

    this.last_online = data.last_online;
    this.last_ip = data.last_ip;
    this.leads = data.leads || [];
    this.leads_log = data.leads_log || [];

    this.referrals = data.referrals || [];
    this.referrals_log = data.referrals_log || [];

    this.not_interested_state = data.not_interested_state || null;
    this.not_interested_state_id = data.not_interested_state_id || null;
    this.ni = data.ni || [];
    this.na = data.na || [];
    this.auto_na_remove_log_rec = data.auto_na_remove_log || null;
    this.na_count = data.na_count || [];
    this.waiting = data.waiting;
    this.ended = data.ended;
    this.is_repopulated = data.is_repopulated || null;
    this.is_merged = data.is_merged || null;
    this.clients_merged = data.clients_merged || [];
    this.merged_to = data.merged_to || {};

    this.is_online = data.is_online || null;

    this.client_waiting = data.client_waiting || [];
    this.client_ended = data.client_ended || [];
    this.retired = data.retired || null;
    this.client_repopulation = data.client_repopulation || [];

    this.transfers = data.transfers || [];
    this.transfers_log = data.transfers_log || [];

    this.answers = data.answers || [];
    this.answers_log = data.answers_log || [];
    this.phones = data.phones || [];
    this.skype = data.skype || [];
    this.email_replays = data.email_replays || [];
    this.emails_approval = data.emails_approval || [];

    this.registered_on = data.registered_on || null;
    this.call_status = data.call_status;
    this.scheduled_calls = data.scheduled_calls || [];
    this.scheduled_calls_log = data.scheduled_calls_log || [];

    this.tech_logs = data.tech_logs || [];

    this.questions_status = data.questions_status;
    this.na_reg_close = data.na_reg_close;

    this.cms_plan = data.cms_plan || null;
    this.cms_plan_log = data.cms_plan_log || [];
    this.cms_password_resets = data.cms_password_resets || [];
    this.cms_sms_log = data.cms_sms_log || [];

    /////Temp//////
    this.comments = data.comments || [];
    //////////////

    this.missedScheduledCall = false;
    this.scheduledCallSoon = false;
    //// this.missedAutoScheduledCall = false; TODO: canceled 29-01-21
    // this.is_na_reg_close = false;  TODO: canceled 29-01-21

    let now = moment();

    if (
      this.scheduled_calls.length &&
      !this.scheduled_calls[0].ended &&
      this.call_status === 2
      //    &&   !this.scheduled_calls[0].is_missed // TODO: ??? does it correct ?? anyway canceled 29-01-21
    ) {
      this.missedScheduledCall = true;
    }

    // if (
    //   this.scheduled_calls.length &&
    //   !this.scheduled_calls[0].ended &&
    //   this.call_status === 2 &&
    //   this.scheduled_calls[0].is_auto &&
    //   this.scheduled_calls[0].is_missed // TODO:  canceled 29-01-21 - no auto statuses
    // ) {
    //   this.missedAutoScheduledCall = true;
    // }

    if (
      this.scheduled_calls.length &&
      !this.scheduled_calls[0].ended &&
      this.call_status === 1
    ) {
      this.scheduledCallSoon = true;
    }
  }
}
